/* lp-hero — galeri kaydırıcı (B1-BUNDLE). Bağımlılık yok. */
(function () {
  if (customElements.get('lp-galeri')) return;

  class LpGaleri extends HTMLElement {
    connectedCallback() {
      this.iz = this.querySelector('[data-iz]');
      this.slaytlar = Array.from(this.querySelectorAll('[data-slayt]'));
      this.noktalar = Array.from(this.querySelectorAll('[data-nokta]'));
      this.geri = this.querySelector('[data-geri]');
      this.ileri = this.querySelector('[data-ileri]');
      if (!this.iz || this.slaytlar.length < 2) return;

      this.aktif = 0;
      this.geri && this.geri.addEventListener('click', () => this.git(this.aktif - 1));
      this.ileri && this.ileri.addEventListener('click', () => this.git(this.aktif + 1));
      this.noktalar.forEach((n) => n.addEventListener('click', () => this.git(Number(n.dataset.nokta))));

      this.iz.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.git(this.aktif + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.git(this.aktif - 1); }
      });

      this.gozlemci = new IntersectionObserver((kayitlar) => {
        kayitlar.forEach((k) => {
          if (k.isIntersecting && k.intersectionRatio >= 0.6) {
            this.isaretle(this.slaytlar.indexOf(k.target));
          }
        });
      }, { root: this.iz, threshold: [0.6] });
      this.slaytlar.forEach((s) => this.gozlemci.observe(s));
      this.isaretle(0);

      const hareketAz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.oto === 'true' && !hareketAz) this.otoBaslat();
    }

    disconnectedCallback() {
      this.gozlemci && this.gozlemci.disconnect();
      clearInterval(this.zamanlayici);
    }

    git(i) {
      const n = this.slaytlar.length;
      const hedef = ((i % n) + n) % n;
      this.iz.scrollTo({ left: this.slaytlar[hedef].offsetLeft - this.iz.offsetLeft, behavior: 'smooth' });
      this.isaretle(hedef);
    }

    isaretle(i) {
      if (i < 0) return;
      this.aktif = i;
      this.noktalar.forEach((n, j) => {
        if (j === i) n.setAttribute('aria-current', 'true');
        else n.removeAttribute('aria-current');
      });
    }

    otoBaslat() {
      const dur = () => clearInterval(this.zamanlayici);
      this.zamanlayici = setInterval(() => this.git(this.aktif + 1), 5000);
      ['pointerdown', 'focusin', 'mouseenter', 'touchstart'].forEach((t) =>
        this.addEventListener(t, dur, { once: true, passive: true })
      );
    }
  }

  customElements.define('lp-galeri', LpGaleri);
})();
